var styleDataHash = 'c5e43852';  
export const injectCss = (() => {
  var css = `.uosoS{height:100%;max-width:100%;position:relative;width:100%}.K2MMs{bottom:0;position:absolute;top:0}[dir] .K2MMs{background:rgba(51,51,51,.05)}[dir=ltr] .K2MMs,[dir=rtl] .K2MMs{left:0;right:0}.IiLdQ{height:100%;overflow:hidden;width:100%}[dir] .IiLdQ{border:0}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





